<template>
  <div>
    <el-dialog
      title="Подтвердите действие"
      :visible.sync="dialogVisible"
      width="30%"
      class="exit-modal"
    >
      <span class="title-modal">Вы действительно хотите выйти?</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">Отмена</el-button>
        <el-button size="mini" type="danger" @click="exit()"> Выйти </el-button>
      </span>
    </el-dialog>

    <div class="header-content">
      <div class="name">
        {{ getOrganizationInfo.organizationName }}
      </div>
      <div class="links">
        <el-link
          v-for="item in domains"
          :key="item.name"
          type="primary"
          :href="item.path"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ item.name }}
        </el-link>
      </div>
      <div class="controls">
        <el-button @click="dialogVisible = true" size="small">Выйти</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      organizationName: "",
      dialogVisible: false,
    };
  },
  mounted() {
    console.log(process.env.NODE_ENV);
  },
  methods: {
    exit() {
      this.$store.dispatch("logout");
      //window.$cookies.remove('time_token_die_adminOrg', '/', process.env.VUE_APP_COOCKIE)
      window.location.replace(process.env.VUE_APP_REDIRECT);
    },
  },
  computed: {
    ...mapGetters(["getOrganizationInfo"]),
    domains() {
      if (this.getOrganizationInfo.domains && this.getOrganizationInfo.hasSite) {
        return this.getOrganizationInfo.domains.map((item) => ({
          name: item,
          path: "https://" + item,
        }));
      }
      return [];
    },
  },
};
</script>

<style scoped>
.header-content {
  height: 60px;
  display: flex;
  justify-content: space-between;
  line-height: normal;
  align-items: center;
}
.name {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-weight: 600;
}
.links {
  flex: 1 1 auto;
  display: flex;
  gap: 1em;
}

::v-deep .exit-modal *.el-dialog__footer {
  padding: 0px 20px 0px;
}
::v-deep .exit-modal *.el-dialog__header {
  padding: 0px 20px 0px;
}
::v-deep .exit-modal *.el-dialog__body {
  padding: 0px 20px;
}
</style>
